export const WIDGET_ID = "result-associated-words";

export const DATE_RANGES = [
  "oneMonth",
  "twoMonths",
  "threeMonths",
  "sixMonths",
  "oneYear",
] as const;
